var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',[_c('template',{slot:"header"},[_vm._v("指定资源")]),_c('d2-markdown',{attrs:{"source":_vm.doc}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }